import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "magnifying_glass",
  "use": "magnifying_glass-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" id=\"magnifying_glass\"><path fill=\"none\" stroke=\"currentColor\" d=\"M18.105 25.21a7.105 7.105 0 100-14.21 7.105 7.105 0 000 14.21zm5.21-1.894l5.306 5.305\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol